import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Chip, CircularProgress, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import GetModelos from '../../data/GetModelos';
import { useAuthContext } from '../../hooks/Auth';
import { post_sandbox } from '../../services/api';
import MarkDownText from '../MarkDownText/MarkDownText';
import InputFileUpload from '../utils/InputFileUpload';
import Temperatura from './Fields/Temperatura';

const SandBox = () => {
  const [responseText, setResponseText] = useState('Aquí aparecerá la respuesta del LLM...');
  const [isLoading, setIsLoading] = useState(false); // Estado para indicar si está cargando
  const { user } = useAuthContext();
  const [imageName, setImageName] = useState();
  const [canUpload, setCanUpload] = useState(true);
  const [isModelWithAttachImage, setIsModelWithAttachImage] = useState(false);
  const { categories, roles, ummiapps, ...usuarioSinCampos } = user || {};


  const [promptData, setPromptData] = useState({
    usuario: usuarioSinCampos,
    temperatura: 0.7,
    modelID: '',
    prompt: '',
    doc: '',
    imageBase64: '',
    isdoc: false,
    format: ''
  });

  const handleSubmit = async () => {
    setIsLoading(true); // Activar el indicador de carga

    console.log({ ...promptData });

    try {

      const { data, status } = await post_sandbox(promptData);

      if (status === 200) {
        const datos = data;
        setResponseText(datos.respuesta)
        return data;

      } else {
        console.error('La solicitud a la API no fue exitosa.');
        return [];
      }
    } catch (error) {
      console.error('Se produjo un error al realizar la solicitud a la API:', error);
      return [];

    } finally {
      setIsLoading(false); // Desactivar el indicador de carga
    }
  };

  const handleFileUpload = (base64, fileName, fileType) => {
    setImageName(fileName);

    if (fileType === 'image') {
      // Almacenar imagen en Base64
      setPromptData((prevState) => ({
        ...prevState,
        imageBase64: base64,
        isdoc: false, 
        format: '' 

      }));
    } else if (fileType === 'document') {
      const format = fileName.endsWith('.pdf') ? 'pdf' : 'docx'; // Detectar el formato
      setPromptData((prevState) => ({
        ...prevState,
        doc: base64,
        isdoc: true, 
        format 
      }));
    }
    setCanUpload(false);
  };


  const handleModeloChange = async (modelo) => {
    console.log({ modelo });
    if (modelo.nombre == 'gemini-1.5-pro' || 'anthropic.claude-3-haiku-20240307-v1:0') {
      setIsModelWithAttachImage(true);
    } else {
      setIsModelWithAttachImage(false);
      setImageName();
    }
    setPromptData((prevProyecto) => ({
      ...prevProyecto,
      modelID: Number(modelo.id)
    }));
  };

  const handlePromptChange = (event) => {
    const nuevoPrompt = event.target.value;
    setPromptData((prevProyecto) => ({
      ...prevProyecto,
      prompt: nuevoPrompt
    }));
  }

  const handleDeleteFile = () => {
    setImageName('');
    setPromptData((prevState) => ({
      ...prevState,
      doc: '',
      imageBase64:'',
      isdoc: false,
      format: ''
    }));
    setCanUpload(true);
  };

  return (
    <Box sx={{ display: 'flex', height: '85vh', padding: 2, width: '100%' }}>
      {/* Contenedor principal dividido en dos columnas */}
      <Grid container spacing={2}>

        {/* Sección de Chat */}
        <Grid item xs={9}>
          <Paper elevation={10} sx={{ padding: 2, display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            <Box sx={{ flexGrow: 1, overflow: 'auto', marginBottom: 5, maxHeight: '50vh' }}>


              {/* Aquí se muestra la respuesta o el indicador de carga */}
              {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', flexDirection: 'column', mt: 40 }}>
                  <CircularProgress />
                  <Typography sx={{ marginLeft: 2 }}>Esperando respuesta del LLM...</Typography>
                </Box>
              ) : (
                <MarkDownText data={responseText} />
              )}
            </Box>

            {/* Espacio para escribir el texto */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                fullWidth
                label="Escribe tu mensaje"
                multiline
                rows={5}
                variant="outlined"
                value={promptData.prompt}
                onChange={handlePromptChange}
                disabled={isLoading} // Desactivar el input mientras carga
              />
              {isModelWithAttachImage && <InputFileUpload onFileUpload={handleFileUpload}  canUpload={canUpload} />}
              <Button
                variant="contained"
                sx={{ marginLeft: 2, height: '100%', backgroundColor: '#2B7C83' }}
                onClick={handleSubmit}
                disabled={isLoading} // Desactivar el botón mientras carga
              >
                Enviar
              </Button>
            </Box>
            {isModelWithAttachImage && imageName &&
              <Stack direction="row" spacing={1} sx={{mt:2}}>
                <Chip
                  label={`Archivo cargado: ${imageName}`}
                  onDelete={handleDeleteFile}
                  deleteIcon={<DeleteIcon  />}
                />
              </Stack>}
          </Paper>
        </Grid>

        {/* Sección lateral de Configuración */}
        <Grid item xs={3}>
          <Paper elevation={10} sx={{ padding: 2, height: '100%' }}>
            <Typography variant="h6">Opciones de configuración</Typography>
            {/* Aquí puedes agregar controles o configuraciones */}
            <Box sx={{ marginTop: 2 }}>
              {/* Ejemplo de opciones */}
              <Temperatura promptData={promptData} setPromptData={setPromptData} />
              <GetModelos onModeloChange={handleModeloChange} />
            </Box>
          </Paper>
        </Grid>

      </Grid>
    </Box>
  );
};

export default SandBox;
